import { atom, useRecoilState } from 'recoil';

const BadgeMintedCount = atom({
  key: 'BadgeMintedCount',
  default: '',
});

export const useBadgeMintedCount = () => {
  return useRecoilState(BadgeMintedCount);
};
